 $(document).ready(function(){

   // on home page load the products in the tab
  $('.widget-product .list-product-tabs').each(function (i, list) {
      $(list).find('li:first').find('a.tab-links').trigger('click')
  });

  // on home page init the slider for 
  $('.ebb-slider').slick({
      dots: true,
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 4,
      dots: false,
      rtl: false,
      speed: 10000,
      autoplay: true,
      autoplaySpeed: 10000,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
  });
});



$(document).on('click', '.ebb-size-navbar', function(){
    $(".navbar-nav").toggleClass("show");
});



// on click tab on the products page 
$(document).on('click', '.product-page-tab-links', function(){
  $('.product-page-tab-links').removeClass('active');
  $(this).addClass('active');
  $('.product-page-tab-content').removeClass('active');
  $($(this).data('id')).addClass('active');
});


// on home page load the products on click of the tabs 
$(document).on('click', '.list-product-tabs .tab-links', function(){
    $(this).parents('.widget-product').find('.tab-links').removeClass('active');
    $(this).parents('.widget-product').find('.tab-content').removeClass('active');
    $(this).addClass('active');
      
    var collection_url = $(this).data('href');
    var sectionID = $(this).parents('.home-product-tabs').attr('sectionid')
    var url = collection_url + '/?view=json&constraint=sectionId%3D' + sectionID;
    var tab_id = $(this).data('id');

    if(  $('#product-tab-' + tab_id ).find('.grid-items').length > 0 ) {
        $('#product-tab-' + tab_id ).addClass('active');
    } else {
        $.ajax({
          type: "get",
          url: url,
          beforeSend: function () {
              $('#product-tab-' + tab_id ).addClass('active');
          },
          success: function (data) {
              $('#product-tab-' + tab_id ).addClass('active');
              $('#product-tab-' + tab_id ).find('.products-grid').html(data);
              $('#product-tab-' + tab_id ).find('.products-grid .product-grids .grid-items').slick({
                    dots: true,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 5,
                    slidesToScroll: 4,
                    dots: false,
                    nextArrow: '<button type="button" class="slick-next"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>',
                    prevArrow: '<button type="button" class="slick-prev"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>',
                    responsive: [
                      {
                        breakpoint: 1024,
                        settings: {
                          slidesToShow: 3,
                          slidesToScroll: 3,
                          infinite: true,
                          dots: true
                        }
                      },
                      {
                        breakpoint: 600,
                        settings: {
                          slidesToShow: 2,
                          slidesToScroll: 2
                        }
                      },
                      {
                        breakpoint: 480,
                        settings: {
                          slidesToShow: 2,
                          slidesToScroll: 2
                        }
                      }
                    ]
              });
          },
          error: function (xhr, text) {
              console.log( text );
              console.log( xhr );
          }
        });
    }
});

// oon change of the swatch in the collection page 
$(document).on('click', '.product-item .product-bottom .item-swatch label', function(){
      var productItemElm = $(this).parents('.product-item');
      $(productItemElm).find('.item-swatch label').removeClass('active');
      $(this).addClass('active');
      var selcted_option_image = $(this).data('img');
      var option_title = $(this).data('value');
      $(productItemElm).find('.product-title .product-option-title').text(' - ' + option_title.replaceAll("-", " / ") );
      if (selcted_option_image) {
         $(productItemElm).find('.product-image .product-grid-image img').attr('src' , selcted_option_image);
      }
});